function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#7f7f7f;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M13,16a2.982,2.982,0,0,1-1.772-5.4,2.929,2.929,0,0,1,3.918.327.381.381,0,0,1,.1.265V13a6.676,6.676,0,0,0,.172,1.526.375.375,0,0,1-.065.317A3.012,3.012,0,0,1,13,16M13,4a9,9,0,0,0,0,18,8.773,8.773,0,0,0,5.152-1.635.747.747,0,1,0-.87-1.215A7.318,7.318,0,0,1,13,20.5,7.5,7.5,0,1,1,20.5,13c0,1.823-.735,3-1.875,3s-1.875-1.177-1.875-3V9.25A.752.752,0,0,0,16,8.5a.742.742,0,0,0-.726.631,4.5,4.5,0,1,0,.872,7.072,2.978,2.978,0,0,0,2.479,1.3C20.642,17.5,22,15.692,22,13a9.007,9.007,0,0,0-9-9",
  transform: "translate(-4 -4)"
});

function SvgIcHabitFrmGmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHabitFrmGmail);
export default ForwardRef;